/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Fragment } from 'react';

import ArticleSearchResult from './ArticleSearchResult';
import ProductSearchResult from './ProductSearchResult';
import { RECORD_TYPES } from './recordTypes';

export default function SearchResult({ hit, hit: { type }, ...props }: any) {
  return type === RECORD_TYPES.PRODUCT ? (
    <ProductSearchResult hit={hit} {...props} />
  ) : type === RECORD_TYPES.ARTICLE ? (
    <ArticleSearchResult hit={hit} {...props} />
  ) : (
    <Fragment />
  );
}
